import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

const Chart = PropTypes.any.isRequired;
const columnIndex = PropTypes.number.isRequired;
const dashboard = PropTypes.object.isRequired;
const editWidget = PropTypes.bool.isRequired;
const errors = PropTypes.object;
const layout = PropTypes.object.isRequired;
const reports = PropTypes.array.isRequired;
const reportsGroups = PropTypes.array.isRequired;
const reportsInGroup = PropTypes.array.isRequired;
const reportsMap = PropTypes.object.isRequired;
const rowIndex = PropTypes.number.isRequired;
const selectedGroup = PropTypes.string;
const selectedReport = PropTypes.string;
const selectedSnapshot = PropTypes.string;
const textRow = PropTypes.object.isRequired;
const vCollect = ImmutablePropTypes.record;
const widgetIndex = PropTypes.number;
const widgetProps = PropTypes.object;

export default {
  Chart,
  columnIndex,
  dashboard,
  editWidget,
  errors,
  layout,
  reports,
  reportsGroups,
  reportsInGroup,
  reportsMap,
  rowIndex,
  selectedGroup,
  selectedReport,
  selectedSnapshot,
  textRow,
  vCollect,
  widgetIndex,
  widgetProps,
};
